<a
  [routerLink]="['/doctors']"
  routerLinkActive="active"
  [class.active]="router.url.includes('/sign-up-consultation')"
>
  <span class="text">{{ 'Лікарі' | translate }}</span>
</a>
